import {Action} from "@ngrx/store";

export const LOAD_BUILDER_CREATED_PAGES: string = '[ai-builder] Load Created Pages';
export const LOAD_BUILDER_CREATED_PAGES_SUCCESS: string = '[ai-builder] Load Created Pages Success';
export const LOAD_BUILDER_CREATED_PAGES_FAIL: string = '[ai-builder] Load Created Pages Fail';

export const LOAD_GENERATED_WEBSITES_COUNT: string = '[ai-builder] Load Generated Websites Count';
export const LOAD_GENERATED_WEBSITES_COUNT_SUCCESS: string = '[ai-builder] Load Generated Websites Count Success';
export const LOAD_GENERATED_WEBSITES_COUNT_FAIL: string = '[ai-builder] Load Generated Websites Count Fail';

export class LoadBuilderCreatedPages implements Action {
  readonly type: string = LOAD_BUILDER_CREATED_PAGES;
  constructor(public payload: number) {}
}

export class LoadBuilderCreatedPagesSuccess implements Action {

  readonly type: string = LOAD_BUILDER_CREATED_PAGES_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {}

}

export class LoadBuilderCreatedPagesFails implements Action {

  readonly type: string = LOAD_BUILDER_CREATED_PAGES_FAIL;
  constructor(public payload: any) {}

}

export class LoadGeneratedWebsiteCount implements Action {
  readonly type: string = LOAD_GENERATED_WEBSITES_COUNT;
  constructor(public payload?: number) {}
}

export class LoadGeneratedWebsiteCountSuccess implements Action {

  readonly type: string = LOAD_GENERATED_WEBSITES_COUNT_SUCCESS;
  constructor(public payload: {
    count: number,
    can_regenerate: boolean
  }) {}

}

export class LoadGeneratedWebsiteCountFail implements Action {

  readonly type: string = LOAD_GENERATED_WEBSITES_COUNT_FAIL;
  constructor(public payload: any) {}

}

export type AiBuilderAction = LoadBuilderCreatedPages |
  LoadBuilderCreatedPagesSuccess |
  LoadBuilderCreatedPagesFails |
  LoadGeneratedWebsiteCountFail |
  LoadGeneratedWebsiteCountSuccess |
  LoadGeneratedWebsiteCount;
